import React from 'react'
import { useExperimentVariables } from '@mc/experiments-react'
import { StyledVariable } from '@mc/feature-variables'
import { useTranslation } from '@mc/i18n'
import { PROMO_FEATURE_FLAG, type PromoFeatureVariables } from '@mc/promo-utils'
import {
  RotatingTitle,
  splitBannerTitle,
} from '../../../pen-7565_v1_promo_banner_200_classes'
import { PROMO_BANNER_ALL_CLASSES_I18N_NAMESPACE } from '../../i18n'

type BannerTitleVariantProps = {
  control: React.ReactNode
  rotate?: boolean
  keepWidth?: boolean
}

export const BannerTitleVariant = ({
  control,
  rotate = false,
  keepWidth,
}: BannerTitleVariantProps) => {
  const { t } = useTranslation(PROMO_BANNER_ALL_CLASSES_I18N_NAMESPACE)
  const variables = useExperimentVariables(
    PROMO_FEATURE_FLAG,
  ) as PromoFeatureVariables
  const title = splitBannerTitle(
    variables?.banner_and_sticky_footer_title?.text,
  )

  if (!title) return <>{control}</>

  const classes = <span>{t('classes')}</span>
  const lead = <StyledVariable text={title.lead} />

  if (rotate) {
    return (
      <RotatingTitle
        lead={lead}
        from={<StyledVariable text={title.promoName} />}
        to={classes}
        keepWidth={keepWidth}
      />
    )
  }

  return (
    <>
      {lead}
      {classes}
    </>
  )
}
